import { z } from 'zod/v4-mini';
import { queryProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';
import { ZodGetLinkConfigOutput, type GetLinkConfigOutput } from '../types/GetLinkConfigOutput.js';

/**
 * Returns the host's config required for linking.
 */
export function getLinkConfig(params: ApiParams<void, 'session', 'config'>): GetLinkConfigOutput {
  return params.ctx.session.config;
}

// Attach a trpc procedure to the function.
getLinkConfig.procedure = queryProcedure<void, GetLinkConfigOutput>(getLinkConfig, z.void(), ZodGetLinkConfigOutput);
